module.exports = __webpack_public_path__ + "static/media/Composition.52f6c711.png";